module.exports = __webpack_public_path__ + "img/hr-dirt-3.3edfc59c.png";